export var PartTrackingType;
(function (PartTrackingType) {
    PartTrackingType[PartTrackingType["TEXT"] = 1] = "TEXT";
    PartTrackingType[PartTrackingType["DATE"] = 2] = "DATE";
    PartTrackingType[PartTrackingType["CHECKBOX"] = 3] = "CHECKBOX";
    PartTrackingType[PartTrackingType["QUANTITY"] = 4] = "QUANTITY";
    PartTrackingType[PartTrackingType["SERIAL_NUMBER"] = 5] = "SERIAL_NUMBER";
    PartTrackingType[PartTrackingType["MONEY"] = 6] = "MONEY";
    PartTrackingType[PartTrackingType["COUNT"] = 7] = "COUNT";
})(PartTrackingType || (PartTrackingType = {}));
//# sourceMappingURL=part-tracking-type.js.map